import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between gap-4 px-4 md:px-8 h-16 md:h-[72px]">
        <a href="#top" className="flex items-center gap-2 shrink-0">
          <span
            className={`w-9 h-9 rounded-lg flex items-center justify-center text-lg ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-cup-line" />
          </span>
          <span
            className={`font-heading font-bold text-base md:text-lg whitespace-nowrap ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            茶杯狐影视
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-1 xl:gap-2">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                    : "text-background-100 hover:text-background-50 hover:bg-background-50/15"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#membership"
            className="hidden md:inline-flex items-center gap-1.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 py-2 whitespace-nowrap transition-colors"
          >
            <i className="ri-vip-crown-line" />
            了解会员
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl transition-colors ${
              scrolled ? "text-foreground-800" : "text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 py-3">
          <ul className="grid grid-cols-2 gap-1">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={() => setMenuOpen(false)}
                  className="block px-3 py-2.5 text-sm rounded-md text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}